/*
 * start.tsx contains all code that should only run in prod/qa, and renders the app to the dom.
 * For code that should run in test + prod, see App.tsx
 * For global-unit-test-only see utils/test/specs.js
 * For individual-unit-test-only see utils/test/render.js
 */

import { renderRoot } from 'quartz-core/client';
import { App } from './App';
import ApplicationContainer from './containers/ApplicationContainer';
import PreviewContainer from './containers/PreviewContainer';
import 'I18n/init/data/currency';

// Rhumb and Routing
import { createBrowserHistory, Switch, Route } from 'quartz-routing/react-router';
import Raven from 'raven-js';
import { getLangPromise } from './utils/locale';
import { getIsCustomDomain, getAllowedParentOrigins } from './utils/urls';
import { createEmbeddedIframeableContainer } from 'payments-checkout-lib/containers/IframeableContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IframeableContainer = createEmbeddedIframeableContainer({
  allowedOrigins: getAllowedParentOrigins()
});
getLangPromise().then(() => {
  const basename = getIsCustomDomain(window.location.hostname) ? '/hs/payments/' : '/payments/';
  renderRoot( /*#__PURE__*/_jsx(App, {
    history: createBrowserHistory({
      basename
    }),
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/iframe/preview",
        children: /*#__PURE__*/_jsx(IframeableContainer, {
          children: /*#__PURE__*/_jsx(PreviewContainer, {
            children: /*#__PURE__*/_jsx(ApplicationContainer, {})
          })
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/iframe",
        children: /*#__PURE__*/_jsx(IframeableContainer, {
          children: /*#__PURE__*/_jsx(ApplicationContainer, {})
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/",
        component: ApplicationContainer
      })]
    })
  }));
}).catch(err => Raven.captureException(err));